import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';

const styles = (theme) => {
  const {
    custom: {
      palette: { colorSupportSlate, colorLightBlue },
    },
    palette: { text },
    spacing: { unit },
  } = theme;

  return {
    icon: {
      color: colorSupportSlate,
      float: 'left',
      fontSize: 18,
      marginRight: 10,
      position: 'relative',
      top: 3,
    },
    root: {
      backgroundColor: colorLightBlue,
      color: text.primary,
      fontWeight: 600,
      padding: `${unit}px ${unit * 2}px`,
      height: 'auto',
      textAlign: 'center',
    },
    text: {
      color: text.primary,
      display: 'inline-block',
      height: '100%',
    },
  };
};

class DowntimeAlert extends PureComponent {
  render() {
    const { classes, message } = this.props;

    return (
      <div className={classes.root}>
        <span className={classes.text}>
          <InfoIcon className={classes.icon} />
          {message}
        </span>
      </div>
    );
  }
}

DowntimeAlert.propTypes = {
  classes: PropTypes.object.isRequired,
  message: PropTypes.string.isRequired,
};

export default withStyles(styles)(DowntimeAlert);
